/**
 * ISO 8601 **with the local offset**, as ai/docs/prro-api.md specifies
 * (`2018-10-17T01:23:00+03:00`) — never `Date.toISOString()`, which emits UTC.
 *
 * Two things break with a `Z` timestamp:
 *
 * - the server compares the literal date parts and ignores the offset, so a
 *   Kyiv calendar month arrives as `Feb 28 22:00 … Mar 31 20:59` and is refused
 *   for spanning more than one month;
 * - a window meant to start at local midnight actually starts at 02:00, so
 *   receipts printed just after midnight fall outside it.
 *
 * Both were measured against the live server.
 */
const pad = (value: number): string =>
  String(Math.floor(Math.abs(value))).padStart(2, "0");

export const toFiscalDateTime = (value: Date): string => {
  const offsetMinutes = -value.getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? "+" : "-";

  return (
    `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}` +
    `T${pad(value.getHours())}:${pad(value.getMinutes())}:${pad(value.getSeconds())}` +
    `${sign}${pad(offsetMinutes / 60)}:${pad(offsetMinutes % 60)}`
  );
};
